module.exports = __webpack_public_path__ + "img/rsz_home-min.e19660e4.png";